import React from "react";
import { Box, CircularProgress } from "@mui/material";

// eslint-disable-next-line react/prop-types
function CenterLoader({ open = false }) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.1)", // overlay
        zIndex: 1300,
      }}
    >
      <CircularProgress size={50} />
    </Box>
  );
}

export default CenterLoader;